import React from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

export interface FlipIdToCaptureBackProps {
  className?: string;
}

function FlipIdToCaptureBack(props: FlipIdToCaptureBackProps) {
  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.flipInner}>
        <div className={clsx(styles.flipCardFront, styles.center)}>
          Flip to Capture Back
        </div>
        <div
          className={clsx(
            styles.flipCardFront,
            styles.flipCardBack,
            styles.center
          )}
        >
          Flip to Capture Back
        </div>
      </div>
    </div>
  );
}

export default FlipIdToCaptureBack;
